var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 369,
    viewBox: "0 0 369 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 152,
    width: 37,
    height: 37,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 152,
    width: 246,
    height: 66,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 164,
    width: 84,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 177,
    width: 149,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 189,
    width: 209,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 201,
    width: 190,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 51,
    width: 37,
    height: 37,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 51,
    width: 262,
    height: 77,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 62,
    width: 84,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 75,
    width: 160,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 87,
    width: 224,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 99,
    width: 204,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 111,
    width: 156,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 242,
    width: 37,
    height: 37,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_323_249)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 242,
    width: 262,
    height: 77,
    rx: 8,
    fill: "white",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 253,
    width: 84,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 266,
    width: 160,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 278,
    width: 224,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 290,
    width: 204,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 302,
    width: 156,
    height: 5,
    rx: 2.5,
    fill: "white",
    fillOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_323_249",
    x: 300,
    y: 152,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_323_249",
    x: 45,
    y: 152,
    width: 246,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_323_249",
    x: 31,
    y: 51,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_323_249",
    x: 73,
    y: 51,
    width: 262,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_323_249",
    x: 31,
    y: 242,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_323_249",
    x: 73,
    y: 242,
    width: 262,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_323_249"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage1);
export default __webpack_public_path__ + "static/media/message1.11809cfc6c566e350fb8aaa2189e62f0.svg";
export { ForwardRef as ReactComponent };